import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import { documents } from "../../../constants/icons";

function CourseBlock({className, carouselImage, carouselTitle, courseDetails, courseLectures, onClick, keyId}) {

  return (
    <div className={`${className || ""} course-block carousel-block p-0 me-1`}>
      <div className="img-carousel" onClick={onClick}>
        <img src={carouselImage} className="img-fluid" />
      </div>
      <div className="desc-carousel" onClick={onClick}>
        <h1>{carouselTitle}</h1>
        <p>{courseDetails}</p>
        <IconDesc icon={documents} paraDesc={courseLectures} />
      </div>
    </div>
  );
}

export default CourseBlock;
